export enum LocalStorageKeys {
  ImageSetOrder = 'ImageSetOrder',
  Inference = 'Inference',
  LicenseNotificationShown = 'LicenseNotificationShown',
  ProjectReadOnlyDialogShown = 'ProjectReadOnlyDialogShown',
  ShowPopupNotifications = 'ShowPopupNotifications',
}
